module.exports = __webpack_public_path__ + "static/media/job_location.0b632ffb.svg";